import { DataTypes } from "../../../data/DataManager";
import { FieldSchema } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";
import { fromNumericCell, toNumericValue } from "./numeric";

export const maintenanceIntervalInDays: FieldSchema = {
  grid: {
    displayed: false,
    order: 44,
    filter: GridFilterTypes.NUMBER,
    integerOnly: true,
  },
  name: "maintenanceIntervalInDays",
  dataTransform: {
    fromCsv: {
      getter: ({ maintenanceIntervalInDays }) => fromNumericCell(maintenanceIntervalInDays),
    },
    toGraphql: {
      getter: ({ maintenanceIntervalInDays }) => toNumericValue(maintenanceIntervalInDays),
    },
    toDb: {
      getter: ({ maintenanceIntervalInDays }) => toNumericValue(maintenanceIntervalInDays),
    },
  },
  data: {
    // An Int in GraphQL and an N in the table, so both writers keep it a number — unlike
    // instrumentGTIN, which is numeric to a reader but stored as text.
    type: DataTypes.NUMBER,
    active: false,
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Maintenance interval in days",
    displayed: false,
    disabled: true,
  },
};
